export default function menu() {
  const nav_dropdown = document.querySelectorAll('.nav_item.dropdown');
  const submenu_nav_btn = document.querySelectorAll('.nav_item .submenu_nav_btn');
  const menu_open = document.querySelector('.menu_open');
  const menu_close = document.querySelector('.menu_close');
  const menu = document.querySelector('.top_nav .menu');

  addToDOMScrollbarWidth();
  document.addEventListener('resize', addToDOMScrollbarWidth)

  nav_dropdown.forEach(el => {

    el.querySelector('.dropdown_btn').addEventListener('click', () => {
      if (!el.classList.contains('active')) {

        el.querySelectorAll('.submenu_nav_btn').forEach(btn => btn.classList.remove('active'));
        el.querySelectorAll('.submenu_item').forEach(item => item.classList.remove('active'));

        const firstSubmenuBtn = el.querySelector('.submenu_nav_btn');
        const firstSubmenuItem = el.querySelector('.submenu_item');
        if (firstSubmenuBtn) firstSubmenuBtn.classList.add('active');
        if (firstSubmenuItem) firstSubmenuItem.classList.add('active');

        nav_dropdownRemoveActive();
        el.classList.add('active');
        el.querySelector('.dropdown_body').classList.add('open');
        document.querySelector('body').classList.add('menu_open');

      } else {
        el.classList.remove('active');
        el.querySelector('.dropdown_body').classList.remove('open');
        document.querySelector('body').classList.remove('menu_open');
      }

    })

    el.querySelector('.go_back_btn').addEventListener('click', () => {
      el.classList.remove('active');
      el.querySelector('.dropdown_body').classList.remove('open');
    })
  });
  function nav_dropdownRemoveActive() {
    nav_dropdown.forEach(element => {
      element.classList.remove('active');
      element.querySelector('.dropdown_body').classList.remove('open');
    });
  }
  submenu_nav_btn.forEach(el => {
    el.addEventListener('click', (e) => {
      submenu_itemRemoveActive();
      e.currentTarget.classList.add('active');
      const id = e.currentTarget.dataset.tabId;
      const submenu_item = document.getElementById(id);
      submenu_item?.classList.add('active');
    })
  });
  function submenu_itemRemoveActive() {
    const submenu_item = document.querySelectorAll('.submenu_itmes .submenu_item');
    submenu_item.forEach(element => {
      element.classList.remove('active');
    });
    submenu_nav_btn.forEach(element => {
      element.classList.remove('active');
    });
  }

  function addToDOMScrollbarWidth() {
    const e = window.innerWidth - document.body.clientWidth;
    document.body.style.setProperty("--scrollbarWidth", `${e}px`)
  }

  menu_open.addEventListener('click', openMenu);
  menu_close.addEventListener('click', closeMenu);
  function openMenu(e) {
    menu.classList.add('open')
    document.querySelector('body').classList.add('menu_open');
  }
  function closeMenu() {
    menu.classList.remove('open')
    document.querySelector('body').classList.remove('menu_open');
  }

  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('menu_open')) {
      nav_dropdownRemoveActive();
      closeMenu();
      document.querySelector('body').classList.remove('menu_open');
    }
  })
}